import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";

function Returns() {
  return (
    <div className="returns">
      <Header />
      <div className="customer-service-content col">
        <div className="customer-service-content-inner">
          <div className="customer-service-body">
            {/* dwMarker="content" dwContentID="45c815e424f19727566958230a" */}
            <div className="returns-page-title-hm">
              <h3>Returns</h3>
            </div>
            <p>&nbsp;</p>
            <p>
              We want you to be delighted with your new purchase. If you need to
              make a return, we're here to help. Please review your item(s) upon
              delivery. Retain packaging if you are considering a return.
            </p>
            <p>&nbsp;</p>
            <ul>
              <li>
                Denowl purchases:{" "}
                <a href="mailto:goods@denowl.shop">goods@denowl.shop</a>
              </li>
            </ul>
            <p>&nbsp;</p>
            <p>
              If you’re not completely satisfied with your purchase, just
              contact us at the email address or phone number above to return or
              exchange eligible items, but please keep the following in mind
              during the return process:
            </p>
            <p>&nbsp;</p>
            <ul>
              <li>
                Please inspect your item(s) upon delivery and report any issues
                to customer service within 30 days.
              </li>
              <li>Returns must be received in original condition.</li>
              <li>Shipping and delivery charges are non-refundable.</li>
              <li>
                Returns are accepted only at our warehouse, except for
                accessories, which may be returned to your local store.
              </li>
              <li>
                Your refund will be reduced by a restocking charge equal to 10%
                of the total purchase price on all items EXCEPT select
                performance seating.
              </li>
              <li>
                Select performance seating will be charged a $99 return shipping
                fee. If packaging is no longer available, a 10% restocking fee
                will be applied in place of the $99 return shipping fee.
              </li>
              <li>
                Returns with a receipt will be refunded in the same form as
                original payment was made.
              </li>
              <li>
                Returns with a gift receipt will be refunded with a merchandise
                credit.
              </li>
              <li>Returns will reflect original discounts and promotions.</li>
              <li>
                Be sure to retain the original packaging materials, receipt, and
                all merchandise tags for returns.
              </li>
              <li>
                Restocking fees will be waived at time of return in the exchange
                process for products of equal or greater value. (EXCEPT Herman
                Miller branded performance seating) Shipping and delivery
                charges are non-refundable. The refund will be a merchandise
                credit.
              </li>
              <li>
                No exchanges can be made for natural variations in marble, stone
                or wood.
              </li>
            </ul>
            <p>&nbsp;</p>
            <p>
              Proof of purchase is required for exchanges, credits, or refunds
              on eligible items, plus amount of tax paid according to applicable
              state law. For your convenience, we will accept the following as
              proof of purchase:
            </p>
            <p>&nbsp;</p>
            <ul>
              <li>Original paper receipt</li>
              <li>Gift receipt</li>
              <li>E-receipt</li>
              <li>Original packing slip</li>
              <li>Gift packing slip</li>
              <li>Order number</li>
            </ul>
            <p>&nbsp;</p>
            <p>
              Upon return, your item will be inspected, and exchanges, credits,
              or refunds will be issued for the purchase price. Tax will be
              refunded in accordance with applicable law. Shipping and delivery
              fees are not refundable except in cases of manufacturing defects
              or transit damage. We reserve the right to refuse returns or
              exchanges of items that are not in like-new condition because of
              misuse or damage caused by a customer. Please keep in mind that
              furniture is vulnerable to damage during shipping. For this
              reason, it’s important that you keep and use the original
              packaging materials for any items you wish to return.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>What can’t you return or exchange?</strong>
            </p>
            <p>&nbsp;</p>
            <ul>
              <li>Gift cards.</li>
              <li>Floor samples and items purchased from Denowl Outlets.</li>
              <li>
                Items marked “final sale” or “non-refundable” are sold “as is”.
              </li>
              <li>Custom and special-order items.</li>
              <li>Items installed cannot be returned.</li>
              <li>
                Preconfigured office bundles cannot be partially returned.
              </li>
              <li>Items delivered internationally via freight forwarder</li>
            </ul>
            <p>&nbsp;</p>
            <p>
              <strong>What is your price adjustment policy?</strong>
            </p>
            <p>&nbsp;</p>
            <p>
              A sale price credit will be honored if an item goes on sale within
              14 days after an order is placed. The credit will be applied to
              the original source of payment for the difference between the
              price that was charged and the sale price. Final sale items are
              excluded from all price adjustments.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>Clearance</strong>
            </p>
            <p>&nbsp;</p>
            <p>
              All sales are final on items that display a “final sale,” with the
              exception of damaged, defective, or incorrect items. If there’s a
              problem with your order, please contact us for assistance within
              three (3) days of receipt. Final sale items are excluded from all
              price adjustments.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>What if I need to cancel my order?</strong>
            </p>
            <p>&nbsp;</p>
            <p>
              We can accept a cancellation of your order for items that have not
              yet shipped or are on backorder. In-stock items normally ship
              within 24–48 hours after an order has been placed. Once an item
              has shipped, cancellation is not possible.
            </p>
            <p>&nbsp;</p>
            <ul>
              <li>
                If you order by credit card, your card will be charged as each
                item is shipped.
              </li>
              <li>Custom and special order items cannot be cancelled.</li>
            </ul>
            <p>&nbsp;</p>
            <p>
              <strong>Risk of Loss</strong>
            </p>
            <p>&nbsp;</p>
            <p>
              All purchased items are made pursuant to a shipment contract. This
              means that the risk of loss and title for such items pass to you
              upon our delivery to the carrier. If your order is placed with a
              purchase order, the shipping terms of FOB shipping dock will
              supersede any shipping terms in your purchase order.
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            {/* END_dwmarker */}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Returns;
